import { useSelector } from 'react-redux';

import StoreColumn from '../../../../../components/columns/store-column';
import Global from '../../../../../store/global-selectors';
import { ALL_STORES_STORE_GUID, useEnhancedReturnRouteMatch } from '../../../../../store/returns/returns.helpers';

type StoreReturnsGridColumnProps = {
  salesOrderGuid: string;
};

export const StoreReturnsGridColumn = ({ salesOrderGuid }: StoreReturnsGridColumnProps) => {
  const { storeGuid: contextStoreGuid } = useEnhancedReturnRouteMatch();
  const isAllStoresView = contextStoreGuid === ALL_STORES_STORE_GUID;

  const salesOrderStore = useSelector((state) =>
    isAllStoresView ? Global.selectEntitiesSalesOrderProperty(state, { salesOrderId: salesOrderGuid, property: 'store' }) : null,
  );

  const storeGuid = isAllStoresView ? (salesOrderStore?.storeGuid ?? '') : contextStoreGuid;

  return <StoreColumn storeGuid={storeGuid} />;
};
